module.exports = __webpack_public_path__ + "img/instagram-icon.4a8c2347.png";